import React, { useEffect, useRef, useState } from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import { TListingClient } from 'types/TListing';

type TAdmarktSimilarItemsAppProps = {
  appState: {
    listing: {
      itemId: TListingClient['itemId'];
      seller: TListingClient['seller'];
      category: TListingClient['category'];
      flags: TListingClient['flags'];
    };
  };
  environment: any;
};

let AdmarktSimilarItems;

const AdmarktSimilarItemsApp = ({ appState, environment }: TAdmarktSimilarItemsAppProps) => {
  const {
    listing: {
      itemId,
      seller,
      category,
      flags: { requestRelevantItems, isAdmarkt },
    },
  } = appState;
  const admarktSimilarItemsRef = useRef<HTMLDivElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const {
    experiments: { isSimilarItemsFeedGroupBEnabled, isSimilarItemsFeedGroupCEnabled },
    isMobileDevice,
  } = environment;

  useEffect(() => {
    if (isAdmarkt || !requestRelevantItems) {
      return;
    }

    const elementRef = admarktSimilarItemsRef.current as Element;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            (async () => {
              try {
                AdmarktSimilarItems = (
                  await import(
                    /* webpackChunkName: "admarktSimilarItems" */ './components/AdmarktSimilarItems/AdmarktSimilarItems'
                  )
                ).default;
                setIsLoaded(true);
              } catch {}
            })();
          }
        });
      },
      {
        rootMargin: '0px 0px 400px 0px',
      },
    );

    if (elementRef) {
      observer.observe(elementRef);
    }

    return () => {
      if (elementRef) {
        observer.disconnect();
      }
    };
  }, [isAdmarkt, requestRelevantItems]);

  if (isAdmarkt || !requestRelevantItems) {
    return null;
  }

  return (
    <EnvironmentProvider value={environment}>
      <div
        className="AdmarktSimilarItemsContainer hz-Page-section hz-Page-section--separated"
        ref={admarktSimilarItemsRef}
      >
        {isLoaded && (
          <AdmarktSimilarItems
            itemId={itemId}
            sellerId={seller.id}
            category={category}
            isSimilarItemsFeedGroupBEnabled={isSimilarItemsFeedGroupBEnabled && !isMobileDevice}
            isSimilarItemsFeedGroupCEnabled={isSimilarItemsFeedGroupCEnabled && !isMobileDevice}
          />
        )}
      </div>
    </EnvironmentProvider>
  );
};

export default AdmarktSimilarItemsApp;
